(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}(g.reduct || (g.reduct = {})).Component = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
(function (global){
(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}(g.reduct || (g.reduct = {})).loggerPackage = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof _dereq_=="function"&&_dereq_;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof _dereq_=="function"&&_dereq_;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
// shim for using process in browser

var process = module.exports = {};
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = setTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    clearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        setTimeout(drainQueue, 0);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],2:[function(_dereq_,module,exports){
(function (process,global){
'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
	value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @private
 *
 * Checks if the given argument is a Number.
 *
 * @param num {*} The argument which will be validated.
 * @returns {boolean}
 *
 */
function _isNumeric(num) {
	return !isNaN(num);
}

var logLevels = {
	ALL: 2,
	WARNINGS: 1,
	SILENT: 0
};

var Logger = (function () {
	/**
  * Sets up internal properties for the logger.
  *
  * @param namespace {String} The optional namespace for the logger.
  * @param logLevel {Number} The optional initial logLevel for the logger.
  */

	function Logger() {
		var namespace = arguments.length <= 0 || arguments[0] === undefined ? '@reduct/logger' : arguments[0];
		var logLevel = arguments.length <= 1 || arguments[1] === undefined ? logLevels.ALL : arguments[1];

		_classCallCheck(this, Logger);

		this.logLevel = logLevel;
		this.namespace = namespace;

		this.instances = [];
	}

	/**
  * Returns customized version of the logger API.
  *
  * @param namespace {String} The namespace of the new logger instance.
  */

	_createClass(Logger, [{
		key: 'getLogger',
		value: function getLogger() {
			var namespace = arguments.length <= 0 || arguments[0] === undefined ? this.namespace : arguments[0];

			var logger = new Logger(namespace, this.logLevel);

			this.instances.push(logger);

			return {
				log: function log(message, appendix) {
					logger.log(message, appendix);
				},

				info: function info(message, appendix) {
					logger.info(message, appendix);
				},

				warn: function warn(message, appendix) {
					logger.warn(message, appendix);
				},

				error: function error(message, appendix) {
					logger.error(message, appendix);
				}
			};
		}

		/**
   * Adjusts the noise of the centralized instance of the logger.
   * 0 => No messages are displayed
   * 1 => Only severe messages are displayed
   * 2 => Every message is displayed
   *
   * @param int {Number} The new log level.
   * @returns {Logger}
   *
   */

	}, {
		key: 'setLogLevel',
		value: function setLogLevel(int) {
			var logLevel = _isNumeric(int) ? int : 2;

			this.logLevel = logLevel;

			this.instances.forEach(function (logger) {
				logger.logLevel = logLevel;
			});

			return this;
		}

		/**
   * Logs a message to the console API if possible.
   *
   * @param message {String} The message to log.
   * @param appendix {*} An optional appendix for the log.
   * @returns {Logger}
   *
   */

	}, {
		key: 'log',
		value: function log(message) {
			var appendix = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];

			if (this.logLevel < logLevels.ALL) {
				return this;
			}

			try {
				console.log(this.namespace + ': ' + message, appendix);
			} catch (e) {}

			return this;
		}

		/**
   * Logs a info to the console API if possible.
   *
   * @param message {String} The message to log.
   * @param appendix {*} An optional appendix for the info log.
   * @returns {Logger}
   *
   */

	}, {
		key: 'info',
		value: function info(message) {
			var appendix = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];

			if (this.logLevel < logLevels.ALL) {
				return this;
			}

			try {
				console.info(this.namespace + ' Info: ' + message, appendix);
			} catch (e) {}

			return this;
		}

		/**
   * Logs a warning to the console API if possible.
   *
   * @param message {String} The message to log.
   * @param appendix {*} An optional appendix for the warning.
   * @returns {Logger}
   *
   */

	}, {
		key: 'warn',
		value: function warn(message) {
			var appendix = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];

			if (this.logLevel < logLevels.WARNINGS) {
				return this;
			}

			try {
				console.warn(this.namespace + ' Warning: ' + message, appendix);
			} catch (e) {}
		}

		/**
   * Logs a error to the console API if possible.
   *
   * @param message {String} The message to log.
   * @param appendix {*} An optional appendix for the error log.
   * @returns {Logger}
   *
   */

	}, {
		key: 'error',
		value: function error(message, appendix) {
			if (this.logLevel < logLevels.SILENT) {
				return this;
			}

			if (appendix) {
				try {
					// We still need the console.error call since the Error object can't print out references to HTML Elements/Objects etc.
					console.error(message, appendix);
				} catch (e) {}

				throw new Error(this.namespace + ' Error: Details are posted above.');
			} else {
				throw new Error(this.namespace + ' Error: ' + message);
			}
		}
	}]);

	return Logger;
})();

//
// Check for the existence of the global reduct object,
// this is duplicate code, but we can't access it otherwise
// since the browserify initialization hooks in later and only in module-system free environments.
//

if (!global.reduct) {
	global.reduct = {};
}

//
// Check for the existence of an logger instance in the global namespace,
// and if none was found create a singleton.
//
if (!(global.reduct.logger instanceof Logger)) {
	var _logger = new Logger();

	//
	// Reduce the logging noise for the unit tests.
	//
	try {
		if (process.env.TEST) {
			_logger.setLogLevel(logLevels.SILENT);
		}
	} catch (e) {}

	global.reduct.logger = _logger;
}

var logger = global.reduct.logger;

exports.logger = logger;
exports.logLevels = logLevels;

}).call(this,_dereq_('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"_process":1}]},{},[2])(2)
});
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"_process":2}],2:[function(_dereq_,module,exports){
// shim for using process in browser

var process = module.exports = {};
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = setTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    clearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        setTimeout(drainQueue, 0);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],3:[function(_dereq_,module,exports){
(function (global){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.component = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _logger = _dereq_('@reduct/logger');

var _utilities = _dereq_('./utilities/');

var _messages = _dereq_('./messages.js');

var messages = _interopRequireWildcard(_messages);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var componentLogger = _logger.logger.getLogger('@reduct/component');
var extractFrom = _utilities.prototype.extractFrom;
var injectInto = _utilities.prototype.injectInto;

/**
 * Helper function which executes all propTypes.
 *
 * @param {Function} context The component instance.
 * @param {Object} passedProps An optional props object which can be directly passed to the class.
 * @returns {Void}
 */

function _validateAndSetProps(context, passedProps) {
	var el = context.el;
	var getDefaultProps = context.getDefaultProps;

	var defaultProps = getDefaultProps();
	var propTypes = context.constructor.propTypes || {};
	var componentName = context._internalName;
	var propNames = Object.keys(propTypes);
	var props = {};

	if (!(0, _utilities.isObject)(defaultProps)) {
		_logger.logger.error('The getDefaultProps() method of Component "' + componentName + '" did not return a valid Object. This can lead to unexpected behavior and Errors.');
	}

	//
	// First of, we need to aggregate all props, either from the passed props, the DOM or the getDefaultProps() method.
	//
	propNames.forEach(function (propName) {
		var value = passedProps[propName] || el.getAttribute('data-' + propName.toLowerCase()) || defaultProps[propName];

		props[propName] = value;
	});

	//
	// After the aggregation is done, we validate the generated props object with the propTypes.
	// If the user passed an object containing a `isOptional` function as the propType, we map the propType to the `isOptional` function.
	// This reduces the overal code needed to defined propTypes and increases similarity with React's syntax.
	//
	propNames.forEach(function (propName) {
		var propTypeTarget = propTypes[propName];
		var propType = (0, _utilities.isObject)(propTypeTarget) && (0, _utilities.isFunction)(propTypeTarget.isOptional) ? propTypeTarget.isOptional : propTypeTarget;
		var isPropTypeInvalid = !(0, _utilities.isFunction)(propType);

		if (isPropTypeInvalid) {
			_logger.logger.error('Invalid propType "' + propName + '" specified in Component "' + componentName + '". Please specify a function as the propType validator.');
		}

		var propTypeResult = propType(props, propName, componentName);

		if ((0, _utilities.isError)(propTypeResult)) {
			_logger.logger.error('The propType for "' + propName + '" in Component "' + componentName + '" returned an Error with the message:\n\n"' + propTypeResult.message + '".');
		}

		//
		// If no error was thrown, and the propType has returned a transformed value,
		// which is not `null` or `undefined`, overwrite the aggregated value.
		//
		if ((0, _utilities.isDefined)(propTypeResult)) {
			props[propName] = propTypeResult;
		}
	});

	// Freeze the props object to avoid further editing off the object.
	context.props = Object.freeze(props);
}

/**
 * Helper function to set initial state variables in the component
 * instance.
 *
 * @param {Function} context The component instance.
 * @returns {Void}
 */
function _setInitialStates(context) {
	var initialState = context.getInitialState();

	if ((0, _utilities.isObject)(initialState)) {
		context.initialStateKeys = Object.keys(initialState);
		context.setState(initialState);
	} else {
		componentLogger.warn('Please return a valid object in the getInitialState() method of "' + context._internalName + '".');
	}
}

var ComponentClass = function () {
	function ComponentClass(element, props, _internalName) {
		_classCallCheck(this, ComponentClass);

		// Fail-Safe mechanism if someone is passing an array or the like as a second argument.
		props = (0, _utilities.isObject)(props) ? props : {};

		if (!(0, _utilities.isDefined)(element)) {
			componentLogger.warn(messages.noElement);
		}

		// The element property for the getElement() method.
		this.el = element || global.document.createElement('div');

		// Holds all props.
		this.props = {};

		// Holds the components state.
		this.state = {};

		// Holds all event listeners.
		this.observers = {};

		// Cache for not hitting the DOM over and over again in the `find` and `findAll` methods.
		this.queryCache = {};

		// Holds all keys of the initial state, used to check for the initial existence of state additions.
		this.initialStateKeys = [];

		// Since the decorator does not maintain it's parent context constructor name,
		// we need to save the internal name for the component as a writable property.
		this._internalName = _internalName || this.constructor.name;

		// Set the props and the initial state of the component.
		_validateAndSetProps(this, props);
		_setInitialStates(this);
	}

	/**
  * Returns the HTML Element on which the Component was mounted upon.
  *
  * @returns {HTMLElement}
  *
  */


	_createClass(ComponentClass, [{
		key: 'getElement',
		value: function getElement() {
			return this.el;
		}

		/**
   * Returns the next found child node by a given selector.
   *
   * @returns {HTMLElement}
   *
   */

	}, {
		key: 'find',
		value: function find(selector) {
			return this.findAll(selector).shift();
		}

		/**
   * Returns all found child nodes by a given selector.
   *
   * @returns {Array<HTMLElement>}
   *
   */

	}, {
		key: 'findAll',
		value: function findAll(selector) {
			var cachedResult = this.queryCache[selector];

			if (cachedResult) {
				return cachedResult;
			}

			var nodeList = this.getElement().querySelectorAll(selector);
			var nodes = Reflect.apply(Array.prototype.slice, nodeList, [nodeList]);

			this.queryCache[selector] = [].concat(_toConsumableArray(nodes));

			return nodes;
		}

		/**
   * The default method which declares the default properties of the Component.
   *
   * @returns {Object} The object containing default props.
   *
   */

	}, {
		key: 'getDefaultProps',
		value: function getDefaultProps() {
			return {};
		}

		/**
   * Returns a boolean regarding the existence of the property.
   *
   * @param propName {String} The name of the property.
   * @returns {boolean} The result of the check.
   *
   */

	}, {
		key: 'hasProp',
		value: function hasProp(propName) {
			return (0, _utilities.isDefined)(this.props[propName]);
		}

		/**
   * The default method which declares the default state of the Component.
   *
   * @returns {Object} The object containing default state.
   *
   */

	}, {
		key: 'getInitialState',
		value: function getInitialState() {
			return {};
		}

		/**
   * Sets all differing state key/value pairs to the Components state.
   *
   * @param delta {Object} The diff object which holds all state changes for the component.
   * @param opts {Object} Optional options object which f.e. could turn off state events from firing.
   */

	}, {
		key: 'setState',
		value: function setState() {
			var delta = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
			var opts = arguments.length <= 1 || arguments[1] === undefined ? { silent: false } : arguments[1];

			var isNotSilent = !opts.silent;
			var previousState = (0, _utilities.cloneObject)(this.state);
			var initialStateKeys = this.initialStateKeys;


			for (var key in delta) {
				if (delta.hasOwnProperty(key)) {
					var newValue = delta[key];
					var oldValue = previousState[key];

					if (initialStateKeys.indexOf(key) === -1) {
						componentLogger.error('Please specify an initial value for \'' + key + '\' in your getInitialState() method of "' + this._internalName + '".');
					} else if (newValue !== oldValue) {
						this.state[key] = newValue;

						if (isNotSilent) {
							this.trigger('change:' + key, {
								key: key,
								value: newValue,
								previousValue: oldValue
							});
						}
					}
				}
			}

			// Trigger the general change event.
			if (isNotSilent) {
				this.trigger('change', {
					delta: delta,
					previousState: previousState
				});
			}
		}

		/**
   * Declares a event listener on the given event name.
   *
   * @param event {String} The name of the event under which the listener will be saved under.
   * @param listener {Function} The listener which will be executed once the event will be fired.
   * @returns {Number} The length of the event listener array.
   *
   */

	}, {
		key: 'on',
		value: function on(event, listener) {
			var targetArray = this.observers[event] || (this.observers[event] = []);

			return targetArray.push(listener);
		}

		/**
   * Triggers the event of the given name with optional data.
   *
   * @todo Support for multiple arguments.
   * @param event {String} The name of the event to trigger.
   * @param data {*} The data to pass to all listeners.
   *
   */

	}, {
		key: 'trigger',
		value: function trigger(event, data) {
			var value = void 0;
			var key = void 0;

			for (value = this.observers[event], key = 0; value && key < value.length;) {
				value[key++](data);
			}
		}

		/**
   * Removes the given listener function from the event of the given name.
   * @param event {String} Name of the event.
   * @param listener {Function} The listener function to remove.
   */

	}, {
		key: 'off',
		value: function off(event, listener) {
			var value = void 0;
			var key = void 0;

			for (value = this.observers[event] || []; listener && (key = value.indexOf(listener)) > -1;) {
				value.splice(key, 1);
			}

			this.observers[event] = listener ? value : [];
		}
	}]);

	return ComponentClass;
}();

//
// First, we export the named `@component` decorator, for simplified usage.
//


var component = exports.component = function component(decoratorPropTypes) {
	return function (CustomComponent) {
		var prototype = extractFrom(CustomComponent);
		var propTypes = decoratorPropTypes || CustomComponent.propTypes || {};
		var componentName = CustomComponent.name;

		return function Wrapper(el, props) {
			var BaseComponent = ComponentClass;

			//
			// Since the base class gets executed first, we need to transfer / reset the
			// getDefaultProps() and getInitialState() method.
			//
			if (prototype.getDefaultProps) {
				BaseComponent.prototype.getDefaultProps = prototype.getDefaultProps;
			} else {
				BaseComponent.prototype.getDefaultProps = ComponentClass.prototype.getDefaultProps;
			}
			if (prototype.getInitialState) {
				BaseComponent.prototype.getInitialState = prototype.getInitialState;
			} else {
				BaseComponent.prototype.getInitialState = ComponentClass.prototype.getInitialState;
			}

			//
			// Create an instance of the component.
			//
			BaseComponent.propTypes = propTypes;
			var base = new BaseComponent(el, props, componentName);
			BaseComponent.propTypes = {};

			//
			// Adjust the prototype of the actual component.
			//
			CustomComponent.prototype = base;

			//
			// Inject the prototype of the `CustomComponent`. This will
			// merge the attributes and the methods of the `CustomComponent`
			// with those from `@reduct/component`.
			//
			injectInto(CustomComponent, prototype);

			return new CustomComponent();
		};
	};
};

//
// Export the ES6 class for users who would like to use it the traditional way.
//
exports.default = ComponentClass;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./messages.js":4,"./utilities/":6,"@reduct/logger":1}],4:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var noElement = exports.noElement = 'No element was specified while creating a instance of a Class. Creating a detached DOM Element instead.';
var extendDeprecate = exports.extendDeprecate = '@reduct/component.extend() is deprecated since v1.0.7 - Use the native ES6 extend instead.';

},{}],5:[function(_dereq_,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.cloneObject = cloneObject;
/**
 * Deep-Clones a object.
 *
 * @param obj {Object} The object to clone.
 * @returns {Object} The cloned object.
 */
function cloneObject() {
	var obj = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

	var target = {};

	for (var i in obj) {
		if (obj.hasOwnProperty(i)) {
			target[i] = obj[i];
		}
	}

	return target;
}

},{}],6:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.prototype = exports.isFunction = exports.isObject = exports.isError = exports.isDefined = exports.cloneObject = undefined;

var _cloneObject = _dereq_('./cloneObject.js');

var _isDefined = _dereq_('./isDefined.js');

var _isError = _dereq_('./isError.js');

var _isObject = _dereq_('./isObject.js');

var _isFunction = _dereq_('./isFunction.js');

var _prototype = _dereq_('./prototype.js');

exports.cloneObject = _cloneObject.cloneObject;
exports.isDefined = _isDefined.isDefined;
exports.isError = _isError.isError;
exports.isObject = _isObject.isObject;
exports.isFunction = _isFunction.isFunction;
exports.prototype = _prototype.prototype;

},{"./cloneObject.js":5,"./isDefined.js":7,"./isError.js":8,"./isFunction.js":9,"./isObject.js":10,"./prototype.js":11}],7:[function(_dereq_,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDefined = isDefined;
/**
 * Checks if the given argument is defined and not `null`.
 *
 * @param val {*} The argument which will be validated.
 * @returns {boolean}
 *
 */
function isDefined(val) {
  return val !== null && val !== undefined;
}

},{}],8:[function(_dereq_,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isError = isError;
/**
 * Checks if the given argument is an instance of the Error Object.
 *
 * @param val {*} The argument which will be validated.
 * @returns {boolean}
 *
 */
function isError(val) {
  return val instanceof Error;
}

},{}],9:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFunction = isFunction;
/**
 * Checks if the given argument is a function.
 *
 * @param func {*} The argument which will be validated.
 * @returns {boolean}
 *
 */
function isFunction(func) {
  return typeof func === 'function';
}

},{}],10:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

exports.isObject = isObject;
/**
 * Checks if the given argument is a object.
 *
 * @param obj {*} The argument which will be validated.
 * @returns {boolean}
 *
 */
function isObject(obj) {
  return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && typeof obj !== 'function' && obj !== null;
}

},{}],11:[function(_dereq_,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var prototype = exports.prototype = {
	extractFrom: function extractFrom(Target) {
		var prototype = {};

		Reflect.ownKeys(Target.prototype).forEach(function (key) {
			if (key !== 'constructor') {
				prototype[key] = Target.prototype[key];
			}
		});

		return prototype;
	},
	injectInto: function injectInto(Target, prototype) {
		for (var key in prototype) {
			if (prototype.hasOwnProperty(key)) {
				Target.prototype[key] = prototype[key];
			}
		}
	}
};

},{}]},{},[3])(3)
});